<template>
  <div
    class="d-flex justify-center"
    style="background-color:black; height: 100%"
  >
    <v-row class="my-4 pt-6 pa-0 ma-5">
      <v-col
        :cols="!check_prticipant ? '12' : '9'"
        :class="
          !check_prticipant
            ? 'd-flex align-center justify-center d-flex flex-column pt-1'
            : 'd-flex align-end justify-end d-flex flex-column pt-1'
        "
      >
        <video
          v-show="checkVideo && isCameraOff"
          :width="!check_prticipant ? '1000px' : '300px'"
          height="auto"
          ref="localVideoElement"
          autoplay
          playsinline
          style="border-radius: 10px"
        ></video>
        <v-card
          v-show="checkVideo && !isCameraOff"
          :width="!check_prticipant ? '1000px' : '300px'"
          :height="!check_prticipant ? '560px' : 'auto'"
          style="border-radius: 10px; background-color: #333334"
          ><v-container fluid fill-height class="d-flex justify-center">
            <v-icon size="160" style="color: #7e7f81">mdi mdi-account</v-icon>
          </v-container></v-card
        >
        <v-card
          v-if="!checkVideo"
          width="1100%"
          height="650px"
          class="d-flex align-center justify-center bg-color"
          style="border-radius: 10px; background-color: #ebf7f7"
        >
          <v-container
            class="d-flex flex-column justify-center align-center fill-height"
            fluid
          >
            <div class="d-flex align-items-center gap-3">
              <span class="text-00A99D w-500 text font-30">สิ้นสุดการโทร</span>
            </div>
          </v-container>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        class="d-flex flex-column justify-center pt-4"
      >
        <v-row class="d-flex flex-column">
          <div ref="remoteVideoContainer"></div>
        </v-row>
      </v-col>

      <v-col
        v-if="check_prticipant"
        cols="7"
        class="d-flex align-center flex-column justify-center pt-0"
      >
        <v-chip
          class="ma-2 pt-0"
          color="indigo"
          text-color="white"
          style="width: auto"
        >
          <v-avatar left>
            <v-icon>mdi-account-circle</v-icon>
          </v-avatar>
          {{ prticipant_name }}
        </v-chip>
      </v-col>

      <v-col
        cols="12"
        class="d-flex justify-center"
        style="margin-bottom: 30px"
      >
        <v-btn
          @click="toggleCamera"
          class="ml-4 mx-4"
          dark
          color="#808080"
          style="border-radius: 8px"
        >
          <v-icon class="mr-2">{{
            isCameraOff
              ? "mdi mdi-camera-outline"
              : "mdi mdi-camera-off-outline"
          }}</v-icon>
          Camera
        </v-btn>
        <v-btn
          v-if="room"
          @click="toggleMicrophone"
          class="mr-4"
          dark
          :color="isMuted ? 'blue' : 'grey'"
          style="border-radius: 8px"
        >
          <v-icon class="mr-2">{{
            isMuted ? "mdi-microphone" : "mdi-microphone-off"
          }}</v-icon
          >Microphone
        </v-btn>
        <v-btn
          v-if="!room"
          @click="connectToLiveKit"
          dark
          color="green"
          style="border-radius: 8px"
        >
          <v-icon class="mr-2">mdi mdi-phone</v-icon>
          Connect
        </v-btn>
        <v-btn
          @click="leaveRoom"
          color="red"
          dark
          v-else
          style="border-radius: 8px"
        >
          <v-icon class="mr-2">mdi mdi-phone-return-outline</v-icon>
          Leave</v-btn
        >
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { Room, createLocalTracks } from "livekit-client";
import buttonSfx from "@/assets/sounds/ring-call.mp3";
var myTrack = new Audio(buttonSfx);
import buttonOpen from "@/assets/sounds/open-close.mp3";
var myTrackOpen = new Audio(buttonOpen);
export default {
  data() {
    return {
      room: null,
      myTrack,
      myTrackOpen,
      url: "https://meet.livekit.io/custom?liveKitUrl=wss://conference-2md9hxj1.livekit.cloud&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3NDEwNjQzODksImlzcyI6IkFQSTQ3ZjI2d0xBQVRlRiIsIm5iZiI6MTc0MTA1NTM4OSwic3ViIjoi4LmC4LiX4LiZ4Li14LmIIOC4l-C4lOC4quC4reC4miIsInZpZGVvIjp7ImNhblB1Ymxpc2giOnRydWUsImNhblB1Ymxpc2hEYXRhIjp0cnVlLCJjYW5TdWJzY3JpYmUiOnRydWUsInJvb20iOiLguKvguYnguK3guIfguJfguJTguKrguK3guJoxIiwicm9vbUpvaW4iOnRydWV9fQ.ZQBZxhdZBJZCr269ATzGeuR19wrgSI9pMbUgbHK24Dg",
      localTracks: [],
      localAudioTrack: null,
      isMuted: true,
      checkVideo: false,
      remoteVideoAttached: false,
      prticipant_name: "",
      sender_name: "",
      check_prticipant: false,
      isRinging: false,
      ringInterval: null,
      isCameraOff: true,
      hasRemoteVideo: false,
      // videoKey: 0,
    };
  },
  // mounted() {
  //    this.$nextTick(() => {
  //     this.checkRemoteVideo();
  //   });
  // },
  // updated() {
  //   this.$nextTick(() => {
  //     this.checkRemoteVideo();
  //   });
  // },
  watch: {
    check_prticipant(newVal) {
      this.check_prticipant = newVal;

      // ถ้ามีการเปลี่ยนแปลงผู้เข้าร่วมใหม่ ให้แนบแทร็กวิดีโอ
      if (newVal) {
        this.room.participants.forEach((participant) => {
          participant.tracks.forEach((publication) => {
            if (publication.track) {
              this.attachTrack(publication.track);
            }
          });
        });
      }
    },
    // isCameraOff() {
    //   this.videoKey++;
    // },
  },
  created() {
    this.incomingCall();
  },
  methods: {
    async connectToLiveKit() {
      try {
        this.checkVideo = true;
        const url = "wss://meet-lab.one.th";
        const token =
          "eyJhbGciOiJIUzI1NiJ9.eyJ2aWRlbyI6eyJyb29tSm9pbiI6dHJ1ZSwiY2FuUHVibGlzaCI6dHJ1ZSwiY2FuUHVibGlzaERhdGEiOnRydWUsImNhblN1YnNjcmliZSI6dHJ1ZSwicm9vbSI6IjIyMzI4OTA2LThlYzgtNDgzMi1iMTliLTgwMTliYzRmZmYyYSJ9LCJpc3MiOiJBUEluQ01VQVI3dU15RjIiLCJleHAiOjE3NDI1NDc3ODcsIm5iZiI6MCwic3ViIjoi4LmB4Lie4LiX4Lii4LmMOiAyNjA4NzQ4NTY2NDI1NzUyLTI2MDg3NDg1NjY0MjU3NTIifQ.iQSNjZ5LayHUXyvZ5u-ACxEbsdHh5FXVKgPl2xlxK0I";

        this.room = new Room();
        await this.room.connect(url, token);
        //  setTimeout(() => {
        console.log("Connected to room:", this.room.name);
        console.log("🔍 Room object after connect:", this.room);
        //  }, 5000);
        this.sender_name = this.room.localParticipant.identity;
        this.isRinging = true;
        await this.incomingCall();

        // 🎥 เปิดกล้องและไมโครโฟนก่อน แล้วค่อย publish
        this.localTracks = await createLocalTracks({
          audio: true,
          video: true,
        });
        // ค้นหาแทร็กเสียงและเปิดใช้งาน
        this.localAudioTrack = this.localTracks.find((t) => t.kind === "audio");
        if (this.localAudioTrack) {
          await this.room.localParticipant.publishTrack(this.localAudioTrack);
          this.localAudioTrack.unmute();
        }

        this.localVideoTrack = this.localTracks.find((t) => t.kind === "video");

        if (this.localVideoTrack) {
          this.localVideoTrack.attach(this.$refs.localVideoElement);
          await this.room.localParticipant.publishTrack(this.localVideoTrack);
          console.log("📡 Published local video track:", this.localVideoTrack);
        } else {
          console.error("Failed to get local video track");
        }

        // แสดงวิดีโอตัวเอง
        const videoTrack = this.localTracks.find((t) => t.kind === "video");
        if (videoTrack) {
          videoTrack.attach(this.$refs.localVideoElement);
          await this.room.localParticipant.publishTrack(videoTrack);
          console.log("📡 Published local video track");
        }
        // Subscribe วิดีโอของผู้เข้าร่วมที่เข้ามาใหม่
        this.room.on("participantConnected", (participant) => {
          console.log(
            "🚀 ~ this.room.on ~ this.room:ddddddddddddddddddddddd",
            this.room
          );
          console.log(
            "🚀 ~ this.room.on ~ participant:ddddddddddddddddd",
            participant
          );
          this.isRinging = false;
          this.stopRinging();
          console.log(`👤 ${participant.identity} joined`);
          this.prticipant_name = participant.identity;
          this.check_prticipant = true;
          this.subscribeToParticipant(participant);
        });
        // Subscribe วิดีโอของผู้เข้าร่วมที่อยู่ในห้องอยู่แล้ว
        const previousParticipants = Array.from(
          this.room.remoteParticipants.values()
        );
        if (previousParticipants) {
          console.log("🚀 ~ previousParticipants", previousParticipants);
          this.subscribeToParticipant(previousParticipants[0]);
        }
      } catch (error) {
        console.error("Error connecting to LiveKit:", error);
      }
    },
    subscribeToParticipant(participant) {
      console.log(`📡 Subscribing to participant: ${participant.identity}`);
      console.log("🚀 ~ subscribeToParticipant ~ participant:", participant);
      // ฟัง event เมื่อ track ถูกเผยแพร่ใหม่
      participant.on("trackPublished", async (publication) => {
        console.log(
          `Track published by ${participant.identity}: ${publication.kind}`
        );

        const track = await publication.track;
        console.log("🚀 ~ participant.on ~ trackkkkkkkkkkkkkkkkkkkkkk:", track);
        if (track) {
          this.attachTrack(track, participant);
        }

        publication.on("subscribed", (track) => {
          console.log(`Subscribed to new track: ${track.kind}`);
          this.attachTrack(track, participant);
        });
      });

      // ตรวจสอบว่าผู้ใช้มี track อยู่แล้วหรือไม่
      participant.tracks.forEach((publication) => {
        if (publication.track) {
          console.log(`Attaching track for ${participant.identity}`);
          this.attachTrack(publication.track, participant);
        }

        publication.on("subscribed", (track) => {
          console.log(`Subscribed to track: ${track.kind}`);
          this.attachTrack(track, participant);
        });

        publication.on("unsubscribed", (track) => {
          console.log(`Track unsubscribed: ${track.kind}`);
        });
      });
    },

    attachTrack(track, participant) {
      console.log(
        `Attaching track: ${track.kind} from ${participant.identity}`
      );
      if (track.kind === "video") {
        let videoElement = document.getElementById(
          `video-${participant.identity}`
        );
        if (!videoElement) {
          videoElement = document.createElement("video");
          videoElement.id = `video-${participant.identity}`;
          videoElement.width = 2200;
          videoElement.height = 600;
          videoElement.autoplay = true;
          videoElement.playsInline = true;
          videoElement.style.borderRadius = "10px";
          this.$refs.remoteVideoContainer.appendChild(videoElement);
        }
        track.attach(videoElement);
        console.log("Remote video attached successfully!");
      }
    },

    toggleMicrophone() {
      if (this.localAudioTrack) {
        this.isMuted = !this.isMuted;

        if (this.isMuted) {
          this.localAudioTrack.unmute(); //เปิดเสียงไมค์
        } else {
          this.localAudioTrack.mute(); //ปิดเสียงไมค์
        }

        console.log(`Microphone ${this.isMuted ? "Muted" : "Unmuted"}`);
      } else {
        console.warn("No local audio track available.");
      }
    },

    toggleCamera() {
      if (this.localVideoTrack) {
        this.isCameraOff = !this.isCameraOff;

        if (this.isCameraOff) {
          this.localVideoTrack.unmute(); // เปิดกล้อง
        } else {
          this.localVideoTrack.mute(); // ปิดกล้อง
        }

        console.log(`Camera ${this.isCameraOff ? "Off" : "On"}`);
      } else {
        console.warn("No local video track available.");
      }
    },

    leaveRoom() {
      this.checkVideo = false;
      this.stopRinging();
      if (this.room) {
        console.log("Leaving room...");

        // ปิด local tracks
        this.localTracks.forEach((track) => track.stop());

        // ออกจากห้อง
        this.room.disconnect();
        this.room = null;

        // เคลียร์วิดีโอ
        if (this.$refs.localVideoElement) {
          this.$refs.localVideoElement.srcObject = null;
        }
        this.$refs.remoteVideoContainer.innerHTML = null;
        if (this.$refs.remoteVideoContainer.innerHTM == null) {
          this.remoteVideoAttached = false;
        }
        this.checkVideo = false;
        this.check_prticipant = false;
        this.remoteVideoAttached = false;
        this.isMuted = true;
        this.isCameraOff = true;
      }
    },

    incomingCall() {
      if (this.isRinging) {
        this.myTrack.play();

        // ตั้งให้เล่นซ้ำทุกครั้งที่เสียงจบ
        this.ringInterval = setInterval(() => {
          this.myTrack.play();
        }, this.myTrack.duration * 3000);
      }
    },
    stopRinging() {
      this.isRinging = false;
      clearInterval(this.ringInterval);
      this.myTrack.pause();
      this.myTrack.currentTime = 0;
    },
    audioOpen() {
      this.myTrackOpen.play();
    },
    // checkRemoteVideo() {
    //    if (this.$refs && this.$refs.remoteVideoContainer !== undefined) {
    //     this.hasRemoteVideo = !!this.$refs.remoteVideoContainer;
    //   }
    // },
  },
};
</script>
<style scoped>
.text {
  background-size: contain;
  z-index: 100;
}

.bg-color {
  height: 100%;
  background-image: url("../assets/img/bg.png");
}
</style>
